import { render, staticRenderFns } from "./setShow.vue?vue&type=template&id=b8449e1c&scoped=true&"
import script from "./setShow.vue?vue&type=script&lang=js&"
export * from "./setShow.vue?vue&type=script&lang=js&"
import style0 from "./setShow.vue?vue&type=style&index=0&id=b8449e1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8449e1c",
  null
  
)

export default component.exports